var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"org-tree-card"},[_c('el-tree',{ref:"orgTree",attrs:{"data":_vm.orgTreeData,"props":_vm.defaultProps,"node-key":"id","highlight-current":"","default-expand-all":""},on:{"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }